import React, { Component } from "react";
import UserImage from "./../../../assets/images/user.jpg";
import FilterActiveIcon from "../../../icons/filteractiveicon";
import FilterIcon from "../../../icons/filtericon";
import service from "../../../services";
import Loader from "../../loader";
import upload from '../../../../src/assets/images/cloud-data-upload-icon.svg';
import moment from "moment";
//Redux Connect
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActCreators } from "../../../redux/bindActionCretor";

import ShowPasswordIcon from '../../../icons/ShowPassIcon';
import ViewIcon from '../../../icons/viewIcon';

import ReactPaginate from "react-paginate";
import commonImage from "../../../commonImage";
import ErrorPopUp from "../../errorPopUp";
import { getName } from "../../../functions";

let sub;
let statusFilterList = [];
const mapStateToProps = (state) => ({
    filmEditId: state.filmEditId,
    otherEventId: state.otherEventId,
    allInitial: state.allInitial
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActCreators, dispatch);
};


class OtherEventsList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activetab: 0,
            exploreotherEventsFlim: [],
            otherEvents: [],
            loaderFlag: false,
            offset: 0,
            perPage: 50,
            screenmodal:false,
            currentPage: 0,
            statusArray: [
                { assign: "Live", list: 1, value: false },
                { assign: "Disable", list: 2, value: false },
            ],
            fileUploading: false,
            errorPopup: false,
            successmodal: false,
            filmId: this.props.filmEditId,
            partnerId: this.props.otherEventId,
        };
        this.apiserve = new service();
    }

    componentDidMount = () => {
        this.apiserve.sendevent("FestivalSetting|getFestivalSetting",{type:'FPG_GUIDE_PDF'});

        let currentPage = localStorage.getItem('currentPage')
        if (currentPage) {
            this.setState(
                {
                    offset: parseInt(localStorage.getItem("offset")),
                    perPage: parseInt(localStorage.getItem("perPage")),
                    currentPage: parseInt(localStorage.getItem("currentPage")),
                },
                () =>
                    this.getNewForntire(this.state.offset, this.state.perPage)
            );
        } else {
            this.setState({
                offset: 0,
                perPage: 50,
                currentPage: 0
            },
                () =>
                    this.getNewForntire(this.state.offset, this.state.perPage))
        }

        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "otherEvent|getList":
                    let data = JSON.parse(JSON.stringify(response.data.docs))
                    data.map(item => {
                        item.dateTime = item.dateTime.sort((a, b) => a.date > b.date ? 1 : -1)
                    })
                    this.setState({
                        otherEvents: response.data.docs,
                        exploreotherEventsFlim: data,
                        pageCount: Math.ceil(response.data.totalDocs / this.state.perPage),
                        loaderFlag: false,
                        allData:this.props.allInitial && this.props.allInitial.otherEvent
                    });
                    break;
                case "fpg|screenerCredential|addPassword":
                    if(!response.error){
                        this.setState({
                            screenmodal: false,
                            password:''
                        })
                    }else{
                        this.apiserve.error(response.error.data ? response.error.data : response.error )
                    }
                    break;
                case "FestivalSetting|setFestivalSetting":
                    if (!response.error) {
                        this.apiserve.sendevent("FestivalSetting|getFestivalSetting",{type:'FPG_GUIDE_PDF'});
                    } else {
                        this.apiserve.error(response.data.error ? response.data.error : response.data)
                    }
                    break;
                case "FestivalSetting|getFestivalSetting":
                    if (!response.error) {
                    this.setState({
                        fileUploading: false,
                        uploadDate: response?.data?.updatedAt,
                        uploadFname: response?.data?.updatedBy?.fname,
                        uploadLname: response?.data?.updatedBy?.lname
                    }, () => {
                        this.setState({
                            uploadPDFModal: true
                        })
                    })
                }
                else {
                    this.apiserve.error(response.data.error)
                }
                    break;
                default:
                    break;
            }
        });
    };

    componentWillUnmount = () => {
        sub.unsubscribe();
        statusFilterList = [];
    };

    getNewForntire = (skip, limit) => {
        this.setState({
            loaderFlag: true
        })
        var data = {
            page: skip,
            limit: limit,
        };
        this.apiserve.sendevent("otherEvent|getList", data);
    };

    editNewFrontier = (item) => {
        this.props.OtherEventsEditData(item)
        this.props.PartnerEventsEditData()
        this.props.NewFrontierEditData()
        this.props.filmEditData()
        this.props.TalkEventEditData()
        this.props.CurrentTab(4)
        this.props.history.push({
            pathname: `/film/${item}`,
            callFrom: 4
        });
    };

    handlePageClick = (e) => {
        const selectedPage = e.selected;
        const offset = selectedPage + 1;

        // page scroll top
        var tbl = document.querySelector(".film_list_table");
        tbl.scrollTo(0, 0);

        this.setState(
            {
                currentPage: selectedPage,
                offset: offset,
                loaderFlag: true,
            },
            () => {
                localStorage.setItem('currentPage', this.state.currentPage)
                localStorage.setItem('offset', offset)
                localStorage.setItem('perPage', this.state.perPage)
                this.getNewForntire(offset, this.state.perPage);
            }
        );
    };

    StatusFilter = (e, selectedInex, isClearStatusType = false) => {
        let index = selectedInex;
        let event = e && e.target && e.target.checked;
        let approvePassList = [...this.state.statusArray];
        approvePassList.forEach((key, i) => {
            if (i === index) {
                approvePassList[i].value = event;
            }
            if (isClearStatusType) {
                approvePassList[i].value = false;
                statusFilterList = [];
            }
        });
        this.setState(
            {
                ...this.state,
                statusArray: approvePassList,
                currentPage: 0,
            },
            () => {
                if (event) {
                    if (index !== null) {
                        statusFilterList = [
                            ...statusFilterList,
                            this.state.statusArray[index].list,
                        ];
                    }
                } else {
                    if (index !== null) {
                        let tempArray = statusFilterList.filter(
                            (d) => d !== this.state.statusArray[index].list
                        );
                        statusFilterList = tempArray;
                    }
                }
                this.getFilmFilter(
                    this.state.offset,
                    this.state.perPage,
                    isClearStatusType
                );
            }
        );
    };

    getFilmFilter = (skip, limit, isClearStatusType) => {
        let data = {
            page: 1,
            limit: limit,
        };

        if (!isClearStatusType && statusFilterList && statusFilterList.length) {
            data.status = statusFilterList;
        }

        this.apiserve.sendevent("otherEvent|getList", data);
    };

    ScreenerPopup = (e,data,filmData) => {
        e.stopPropagation();
        this.setState({
            screenmodal:true,
            ScreenerPopupData:data,
            ScreenerPopupFilmData:filmData
        })
    }
  
    scannerLogin = (e,date,item) => {
        e.stopPropagation();
        e.preventDefault();
        let data = {}
        data.film = date._id
        data.filmType = "PartnerEvent"
        let scannerLogin = this.apiserve.e(data)
        window.open(process.env.REACT_APP_FRONTEND_ORIGIN_CMS + 'moderator/signin?data=' + scannerLogin);
  
    }

    scannerSave = (date,data) => {
        const isValid = this.validate()
        if (isValid) {
        var data = {
            "filmId": data._id,
            "date": date._id,
            "filmType": "OtherEvent",
            "password": this.state.password
        }
        this.apiserve.sendevent("fpg|screenerCredential|addPassword",data);
    }
    }

    validate = () => {
        let passwordErr = '';
        if (!this.state.password) {
            passwordErr = 'Password can not be blank'
        }
        else {
            if (!this.state.password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d[\]{};:=<>_+^#$@!%*?&]{8,30}$/)) {
                passwordErr = 'Password must be at least 8 characters and include one lowercase letter, one uppercase letter, and one digit.';
            } else {
                passwordErr = ''
            }
        }
        
        this.setState({
            passwordErr
        })
        if (passwordErr) {
            return false
        }
        return true
    }
    
    Showpassword = () => {
        this.setState({
            showPass: !this.state.showPass
        })
    }
    
    onInputChange = (e) => {
        const {name,value} = e.target
        let passwordErr = ''
        if(value.length > 0){
            if (!value.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d[\]{};:=<>_+^#$@!%*?&]{8,30}$/)) {
                passwordErr = 'Password must be at least 8 characters and include one lowercase letter, one uppercase letter, and one digit.';
            } else {
                passwordErr = ''
            }
        } else {
            passwordErr = 'Password can not be blank'
        }
        this.setState({
            passwordErr : passwordErr,
            [name]:value
        })
    }

    getLocationslist = (locations) => {

        let emptyData = []
      
        locations.map(location => {
          emptyData.push(location.name)
        });
      
        return emptyData.join(', ')
      }

      uploadPDF = (e) => {
        let file = e.target.files[0];
        if ((file.type === 'text/pdf') || file.name.includes('.pdf')) {
            this.setState({
                fileUploading: true
            })
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = (event) => {
                setTimeout(() => {
                    this.imageUploadScreen(file,true,event.target.result);
                }, 0);
            };
            e.target.value = ''
        } else {
            this.setState({ errorMsg: 'please upload .PDF file only', errorPopup: true, fileUploading: false })
        }
    }

    imageUploadScreen = (file,IsFPGUpload=false,img) => {
        var fileSet = commonImage(file,IsFPGUpload,'',img)
        fileSet.then((value) => {
            var data = {
                url: encodeURI(process.env.REACT_APP_IMAGE_URL + value),
                type:('FPG_GUIDE_PDF'),
            }
            this.apiserve.sendevent("FestivalSetting|setFestivalSetting", data);   
        });
    };



    errorMsgPopup = () => {
        this.setState({
            errorPopup: false
        })
    }
    
    CloseModal = () => {
        if ( this.state.successmodal === true ) {
            this.props.getLoginRole && this.props.getLoginRole.user && this.props.getLoginRole.user.role === 'general' ?
                this.getGeneralList(this.state.offset, this.state.perPage) :
                this.getEventList(this.state.offset, this.state.perPage);
        }
        this.setState({
            successmodal: false,
        })
    }

    render() {
        const { exploreotherEventsFlim,filmId, statusArray, ScreenerPopupData,ScreenerPopupFilmTitle,ScreenerPopupFilmData } = this.state;
        console.log(filmId,"filmId");
        return (
            <>
                <div className="table_wrap film_list_table striped_table">
                    <table>
                        <thead>
                            <tr>
                                <th></th>
                                <th>Category</th>
                                <th>Accessibility</th>
                                <th style={{ width: "325px" ,display:'flex'}}>Date-Time (MT)-Location
                                </th>
                                <th>
                                    <span className="disp_flex d_flex_align_center">
                                        Status
                                        {statusFilterList && statusFilterList.length ? (
                                            <FilterActiveIcon />
                                        ) : (
                                                <FilterIcon />
                                            )}
                                    </span>
                                    <div className="tabelData_popup">
                                        <form>
                                            <div className="customCheck">
                                                <div className="customCheckBox clear_all_popup d_flex d_flex_justify_spacebt">
                                                    <p
                                                        className="link"
                                                        onClick={() => this.StatusFilter(null, null, true)}
                                                    >
                                                        Clear All
                                                </p>
                                                </div>

                                                <div className="customCheckBox">
                                                    {statusArray.map((item, i) => (
                                                        <div className="customCheckBox">
                                                            <input
                                                                type="checkbox"
                                                                id={"status" + item.list}
                                                                name={"status" + item.list}
                                                                value={item.list ? true : false}
                                                                checked={item.value ? true : false}
                                                                onClick={(e) => this.StatusFilter(e, i)}
                                                            />
                                                            <label htmlFor={"status" + item.list}>
                                                                {item.assign}
                                                            </label>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {exploreotherEventsFlim &&
                                exploreotherEventsFlim.length > 0 &&
                                exploreotherEventsFlim.map((item) => (
                                    <tr onClick={() => this.editNewFrontier(item._id)} className={`pointer ${item.status === 2 ? 'disable' : ''}`}>
                                        <td style={{ width: "325px" }}>
                                            <div className="disp_flex">
                                                <div className="film_banner">
                                                    <img src={
                                                        item.images.inSite ? this.apiserve.imageUrl + item.images.inSite :
                                                            item.images.link ? item.images.link :
                                                                '/images/image-placeholder.png'}
                                                    />
                                                </div>
                                                <div className="film_desc">
                                                    <h3>{item.title}</h3>
                                                    <div className="disp_flex d_flex_align_center">
                                                        <span>{item.runTime}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td style={{ width: "400px" }}>
                                            <div>
                                                <p>
                                                    {item && item.category && getName(item.category, this.props.allInitial && this.props.allInitial.otherEvent && this.props.allInitial.otherEvent.category)}
                                                </p>
                                            </div>
                                        </td>
                                        <td style={{ width: "400px" }}>
                                            <div>
                                                {item.accessibility &&
                                                    item.accessibility.map((e) => {
                                                        return <p>{getName(e, this.props.allInitial && this.props.allInitial.otherEvent && this.props.allInitial.otherEvent.accessibility )}</p>;
                                                    })}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item.dateTime && item.dateTime.length >= 1 ?
                                                    item.dateTime.map((date) => {
                                                        return (
                                                            <div className="d_flex d_flex_align_center mb_5">
                                                                {date.date !== undefined && <>
                                                                    <p className="aa" style={{width:"315px"}}>{moment(date.date).tz("US/Mountain").format('MMM DD - h:mm A')} - {moment(date.endDate).tz("US/Mountain").format('MMM DD - h:mm A')} { date.locationType === undefined || date.locationType === "2" ? '- Online' : date.locations.length > 0 ? ' - ' + this.getLocationslist(date.locations) : ''}</p>
                                                                </>}
                                                            </div>
                                                        )
                                                    })
                                                    :
                                                ''}
                                            </div>
                                        </td>
                                        <td style={{ width: "200px" }}>
                                            <div>
                                                <p>
                                                    {item.status === 1
                                                        ? "Live"
                                                        : item.status === 2
                                                            ? "Disabled"
                                                            : ""}
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>

                    {/* Loader */}
                    {this.state.loaderFlag ? <Loader /> : ""}

                        {/* For CSV upload successfully */}
                        <div className={`user_popup ${this.state.successmodal ? "active" : null}`}>
                        <span className="popup_overlay" onClick={this.CloseModal}></span>
                        <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
                            <div className="approve_popup_header text_center relative">
                                <p>You have successfully uploaded {this.state.totalAddedRecord} users</p>
                            </div>
                            <div className="content">
                                <div className="field_row text_center">
                                    <button className="small_btn active" onClick={this.CloseModal}>OK</button>
                                </div>
                            </div>
                        </div>
                    </div>

               {this.state.errorPopup ?
                    <ErrorPopUp
                        errorMsg={this.state.errorMsg}
                        errorMsgPopup={this.errorMsgPopup}
                    />
                    : ''
                }

                    {/* Screen Modal */}
                    {
                        this.state.screenmodal ? 
                        <div className="screener_popup">
                            <div className="screener_popup_innerpopup">
                                <div className="screener_popup_header text_center">
                                    <h3 className="mb_10"> Screener Credentials</h3>
                                    <p>{ScreenerPopupFilmTitle} </p>
                                    <p>{moment(ScreenerPopupData.date).tz("US/Mountain").format('MMM DD - h:mm A') + ' MT'} </p>
                                </div>
                                <div className="screener_popup_content">
                                    <form>
                                        <h3 className="mb_5">PIN</h3>
                                        <h2 className="mb_15">{ScreenerPopupData.screenerCredential.pin}</h2>
                                        <div className="field_row">
                                            <div className="field_row_inner">
                                                <label>Password</label>
                                                <div className="field_input relative">
                                                    <input
                                                        type={this.state.showPass ? "text" : "password"}
                                                        name="password"
                                                        id="password"
                                                        value={this.state.password}
                                                        onChange={this.onInputChange}
                                                    />
                                                    <span className="eye_icon"  onClick={this.Showpassword}> { this.state.showPass ? <ShowPasswordIcon />  : <ViewIcon /> } </span>
                                                </div>
                                                <span className='error srv-validation-message'>{this.state.passwordErr}</span>
                                            </div>
                                            
                                        </div>
                                        <div className="field_row pt_25">
                                            <button type='button' onClick={() => this.setState({screenmodal:false,passwordErr:'',password:''})}>CANCEL</button>
                                            <button className="active" type='button' onClick={()=>this.scannerSave(ScreenerPopupData,ScreenerPopupFilmData)}>SAVE</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        :
                        ""       
                    }

                </div>

                <span className="head_btn pointer upload_pdf_btn"  style={{marginLeft:'17px',marginTop:'10px'}}><input type="file" accept='.pdf'  onChange={this.uploadPDF} className="upload_pdf"/>Upload PDF <img src={upload} style={{width:'20px',marginLeft:'10px'}} /> {this.state.fileUploading &&
                    <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                }</span> 
                 <span style={{marginLeft:'17px'}}>Last Uploaded {moment(this.state.uploadDate).tz("US/Mountain").format('DD/MM/YYYY')} {moment(this.state.uploadDate).tz("US/Mountain").format('h:mm A')} by {this.state.uploadFname} {this.state.uploadLname}</span>

                {/* ReactPaginate  */}
                {exploreotherEventsFlim &&
                    exploreotherEventsFlim.length &&
                    exploreotherEventsFlim ? (
                        <div className="custom-pagination">
                            <ReactPaginate
                                previousLabel={""}
                                nextLabel={""}
                                breakLabel={"..."}
                                breakClassName={"break-me"}
                                pageCount={this.state.pageCount}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                onPageChange={this.handlePageClick}
                                containerClassName={"pagination"}
                                subContainerClassName={"pages pagination"}
                                activeClassName={"active"}
                                forcePage={this.state.currentPage}
                            />
                        </div>
                    ) : (
                        ""
                    )}
            </>
        )
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OtherEventsList);
